import React, { Component } from 'react'
import { reserve ,contactPay} from '../../../slices/modalSlice';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import '../../../style/css/particulier/paiment.css'

 class ReserveBtn extends Component {
    constructor(props) {
        super(props);
        this.reserveForm = this.reserveForm.bind(this)
    }
    reserveForm = () =>{
        this
      .props
      .dispatch(reserve())
      }

      toogleClose = () =>{
        this
        .props
        .dispatch(reserve())
    }

    reserver = (e) => {
        let event = e
        console.log(event);
        switch (event) {
            case "reserve": return this.props.reserve; break;
            case "contact": return this.props.contactPay; break;
        }
    }


    
    render() {
        return (
            <>
            <button  onClick={this.reserver(this.props.event)} className={"reserveActions__btn"+" "+this.props.className} style={{backgroundColor:this.props.color, height: this.props.height,width:this.props.width}}>
                {this.props.content}
                <img className="reserveActions__icons" src={this.props.icon} alt="" />
            </button>
            </>
        )
    }
}
const mapDispatchToProps =  {
    contactPay,
    reserve
  }


export default withRouter(connect(null,mapDispatchToProps)(ReserveBtn));